// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************************Toggle CSS Started****************************/ 
  .button {
    position: relative;
    top: -18%;
    width: 85px;
    height: 35px;
    margin: -20px auto 0 auto;
    border: 1px solid #358696;
    overflow: hidden;
    left: 0px;
}
  .button.b2 {
	border-radius: 2px;
	border-radius: 35px;
  }
#myDIV {
    background: #358696;
    text-align: initial;
}
.togglebtn {
    border: none;
    outline: none;
    padding: 9px 8px;
    cursor: pointer;
    font-size: 12px;
	font-weight: 500;
}
/* Style the active class, and buttons on mouse-over */
.ev_bus {
    background: #358696;
    color: white;
}
button.togglebtn {
  background-color: #fff;
  color: #000;
}
button.togglebtn.active {
    background-color: #358696;
    color: #fff;
}
/*******************************Toggle Css Ended*********************************/`, "",{"version":3,"sources":["webpack://./src/componets/Login/toggle.css"],"names":[],"mappings":"AAAA,kFAAkF;EAChF;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;AACb;EACE;CACD,kBAAkB;CAClB,mBAAmB;EAClB;AACF;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,eAAe;CAClB,gBAAgB;AACjB;AACA,sDAAsD;AACtD;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA,iFAAiF","sourcesContent":["/***********************************Toggle CSS Started****************************/ \r\n  .button {\r\n    position: relative;\r\n    top: -18%;\r\n    width: 85px;\r\n    height: 35px;\r\n    margin: -20px auto 0 auto;\r\n    border: 1px solid #358696;\r\n    overflow: hidden;\r\n    left: 0px;\r\n}\r\n  .button.b2 {\r\n\tborder-radius: 2px;\r\n\tborder-radius: 35px;\r\n  }\r\n#myDIV {\r\n    background: #358696;\r\n    text-align: initial;\r\n}\r\n.togglebtn {\r\n    border: none;\r\n    outline: none;\r\n    padding: 9px 8px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n\tfont-weight: 500;\r\n}\r\n/* Style the active class, and buttons on mouse-over */\r\n.ev_bus {\r\n    background: #358696;\r\n    color: white;\r\n}\r\nbutton.togglebtn {\r\n  background-color: #fff;\r\n  color: #000;\r\n}\r\nbutton.togglebtn.active {\r\n    background-color: #358696;\r\n    color: #fff;\r\n}\r\n/*******************************Toggle Css Ended*********************************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
